import React from 'react';
import './PercentageChange.css';

const PercentageChange = ({ percentage }) => {

  const blockName = 'percentage-change';
  const classList = [blockName];
  let chevron = null;

  if (percentage > 0) { classList.push(`${blockName}--positive`); chevron = '\u2191'; }
  if (percentage === 0) { classList.push(`${blockName}--no-change`); }
  if (percentage < 0) { classList.push(`${blockName}--negative`); chevron = '\u2193'; }

  return (
    <small className={classList.join(' ')}>
      {chevron} {percentage.toFixed(2)}%
    </small>
  )
}

export default PercentageChange



// WEBPACK FOOTER //
// ./src/components/PercentageChange/PercentageChange.js